import { createContext, useContext } from 'react';

export const PageContextInitialState = 1;

export type PageContextType = {
  page: number;
  setPage: (page: number) => void;
};

export const PageContext = createContext<PageContextType>({
  page: PageContextInitialState,
  setPage: () => {},
});

export const usePageContext = (): PageContextType => useContext(PageContext);
